'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// As this file grows it could be split into other files and then those
// can be imported into this one.
const LEGWORK_LOGO = 'images/legwork-2019-logo-01.svg';
const LARGE_SCREEN = 1100; // Greater thant this is consider large

exports.LARGE_SCREEN = LARGE_SCREEN;
exports.LEGWORK_LOGO = LEGWORK_LOGO;
